// import React, {useEffect, useRef, useState} from "react";
// import {arraySorter, DatePicker, Form, InputBox, notification, Table} from "../../components/Elements/appUtils";
// import PageHeader from "../../components/Elements/pageHeader";
// import _ from "lodash";
// import {captainReportingFxn, fetchProduct, GroupedProductList, orderReportingFxn,combinedReportingFxn} from "../products/actions";
// import {GetEachFormFields} from "../../components/_utils/formUtils";
// import moment from "moment";
//
// function OrderReporting(props) {
//     let tableRef = useRef();
//     const {getFieldValue} = props.form;
//     let [products, setProducts] = useState([]);
//     const [activeTab, setActiveTab] = useState("today");
//     const [dates, setDates] = useState({
//         fromDate: '',
//         toDate: '',
//     });
//
//     const handleDateTab = (key) => {
//         setActiveTab(key);
//
//         const today = new Date();
//         let from, to;
//
//         switch (key) {
//             case "today":
//                 from = to = today;
//                 break;
//
//             case "7days":
//                 from = new Date();
//                 from.setDate(today.getDate() - 7);
//                 to = today;
//                 break;
//
//             case "1month":
//                 from = new Date();
//                 from.setMonth(today.getMonth() - 1);
//                 to = today;
//                 break;
//
//             case "3months":
//                 from = new Date();
//                 from.setMonth(today.getMonth() - 3);
//                 to = today;
//                 break;
//
//             case "custom":
//                 from = '';
//                 to = '';
//                 break;
//
//             default:
//                 from = to = today;
//         }
//
//         setDates({fromDate: from, toDate: to});
//     };
//
//     // const apiRequest = (params) => {
//     //     return new Promise(async (resolve) => {
//     //         try {
//     //             if (dates.fromDate && dates.toDate) {
//     //                 params.fromD = moment(dates.fromDate).startOf('day')._d
//     //                 params.toD = moment(dates.toDate).endOf('day')._d
//     //             }
//     //             // const data = await orderReportingFxn({...params});
//     //             const data = await combinedReportingFxn({ ...params });
//     //             resolve(data);
//     //         } catch (error) {
//     //             console.error("Error fetching data:", error);
//     //         }
//     //     });
//     // };
//     const apiRequest = (params) => {
//         return new Promise(async (resolve) => {
//             try {
//                 if (dates.fromDate && dates.toDate) {
//                     params.fromD = moment(dates.fromDate).startOf('day')._d;
//                     params.toD = moment(dates.toDate).endOf('day')._d;
//                 }
//
//                 const response = await combinedReportingFxn({ ...params });
//                 console.log("Full API Response:", response);
//
//                 let finalData = [];
//                 let finalTotal = 0;
//
//                 // 1. Check if response itself is the array
//                 if (Array.isArray(response)) {
//                     finalData = response;
//                     finalTotal = response.length;
//                 }
//                 // 2. Check if it's response.data.data (Double nested)
//                 else if (response?.data?.data && Array.isArray(response.data.data)) {
//                     finalData = response.data.data;
//                     finalTotal = response.data.total || response.data.count || finalData.length;
//                 }
//                 // 3. Check if it's response.data (Single nested)
//                 else if (response?.data && Array.isArray(response.data)) {
//                     finalData = response.data;
//                     finalTotal = response.total || response.count || finalData.length;
//                 }
//
//                 console.log("Extracted Data for Table:", finalData);
//
//                 resolve({
//                     data: finalData,
//                     total: finalTotal
//                 });
//
//             } catch (error) {
//                 console.error("Error fetching data:", error);
//                 resolve({ data: [], total: 0 });
//             }
//         });
//     };
//
//     const getProducts = async (params = {}) => {
//         params.results = 10000
//         const data = await fetchProduct({...params});
//         setProducts(arraySorter(data.data.data))
//     }
//
//     useEffect(() => {
//         getProducts()
//         let currentDate = moment();
//         let firstDayOfMonth = moment(currentDate).startOf('month');
//         let lastDayOfMonth = moment(currentDate).endOf('month');
//         props.form.setFieldsValue({
//             fromD: firstDayOfMonth,
//             toD: lastDayOfMonth,
//         });
//         // loadTables() //4-6-24
//         // loadUsers() //4-6-24
//     }, [])
//
//     useEffect(() => {
//         let fromDate = getFieldValue('fromD');
//         let toDate = getFieldValue('toD');
//         const fromDateObj = new Date(fromDate);
//         const toDateObj = new Date(toDate);
//         const timeDifference = Math.abs(toDateObj.getTime() - fromDateObj.getTime());
//         const differenceInDays = Math.ceil(timeDifference / (1000 * 3600 * 24));
//
//         if (differenceInDays > 31) {
//             notification.warning({
//                 message: 'Difference Between From Date And To Date Cannot Exceeds 1 Month'
//             });
//             props.form.setFieldsValue({
//                 toD: ''
//             })
//         }
//     }, [getFieldValue('fromD'), getFieldValue('toD')])
//
//
//     const refreshTable = () => {
//         tableRef.current.reload();
//     };
//
//
//     // const changeLog = (record) => (
//     //     <>
//     //         Order (Bill No.:{record.orderNo}) total amount changed from
//     //         Rs. {record && record.subTotal} to {record.customerPaid ? record.customerPaid : 0} by {record && record.userId && record.userId.name}
//     //         {' '}Discount changed from Rs. 0 to {record && record.discount ? record.discount : 0}.<br/>
//     //         Service Charge 5% changed from Rs. 0 to
//     //         Rs. {record && record.serviceTaxAmount ? record.serviceTaxAmount : 0} (Electron Pos)
//     //         - {record && record.dayOpenDate && moment(record.dayOpenDate).format('DD-MM-YYYY')} Order (Bill
//     //         No.:{record.orderNo}, Amount: {record.customerPaid}) is created
//     //         by {record && record.userId && record.userId.name}
//     //     </>
//     // const changeLog = (record) => {
//     //     if (record.reportType === "KOT") {
//     //         return <>Order (Bill No.:{record.orderNo}) {record.message || "-"} by {record.userName || ""}</>;
//     //     }
//     //
//     //     const subTotal = Number(record?.subTotal || 0);
//     //     const discount = Number(record?.discount || 0);
//     //     const serviceTaxAmount = Number(record?.serviceTaxAmount || 0);
//     //     const finalAmount = Number(record?.netAmount || 0);
//     //     const amountAfterDiscount = subTotal - discount;
//     //
//     //     return (
//     //         <>
//     //             Order (Bill No.:{record.orderNo}) total amount changed Rs. {subTotal} to Rs. {amountAfterDiscount} by {record?.userId?.name || ""}
//     //             {' '}Discount changed Rs. 0 to Rs. {discount}.<br/>
//     //
//     //             {serviceTaxAmount > 0 ? (
//     //                 <>
//     //                     GST/Service Charge changed Rs. 0 to Rs. {serviceTaxAmount}.<br/>
//     //                 </>
//     //             ) : null}
//     //
//     //             Final Amount is Rs. {finalAmount}
//     //             {' '} - {record?.dayOpenDate && moment(record.dayOpenDate).format('DD-MM-YYYY hh:mm A')} updated by {record?.userId?.name || ""}
//     //         </>
//     //     );
//     // };
//
//     // const changeLog = (record) => {
//     //     if (record.reportType === "KOT") {
//     //         return <>Order (Bill No.:{record.orderNo}) {record.message || "-"} by {record.userName || ""}</>;
//     //     }
//     //
//     //     const subTotal = Number(record?.subTotal || 0);
//     //     const discount = Number(record?.discount || 0);
//     //     const serviceTaxAmount = Number(record?.serviceTaxAmount || 0);
//     //     const finalAmount = Number(record?.netAmount || 0);
//     //     const amountAfterDiscount = subTotal - discount;
//     //
//     //     let message = `Order (Bill No.:${record.orderNo}) subtotal Rs. ${subTotal}, after discount Rs. ${amountAfterDiscount}, discount changed Rs. 0 to Rs. ${discount}`;
//     //
//     //     if (serviceTaxAmount > 0) {
//     //         message += `, GST/Service Charge changed Rs. 0 to Rs. ${serviceTaxAmount}`;
//     //     }
//     //
//     //     message += `, final amount Rs. ${finalAmount} by ${record?.userId?.name || ""}`;
//     //
//     //     return <>{message}</>;
//     // };
//     // const changeLog = (record) => {
//     //     const tableLabel = record?.tableNo || record?.tableName || "-";
//     //
//     //     if (record.reportType === "KOT") {
//     //         return (
//     //             <>
//     //                 Order (Bill No.:{record.orderNo}, Table:{tableLabel}){" "}
//     //                 {record.message || "-"} by {record.userName || ""}
//     //             </>
//     //         );
//     //     }
//     //
//     //     const subTotal = Number(record?.subTotal || 0);
//     //     const discount = Number(record?.discount || 0);
//     //     const serviceTaxAmount = Number(record?.serviceTaxAmount || 0);
//     //     const finalAmount = Number(record?.netAmount || 0);
//     //     const amountAfterDiscount = subTotal - discount;
//     //
//     //     let message = `Order (Bill No.:${record.orderNo}, Table:${tableLabel}) subtotal Rs. ${subTotal}, after discount Rs. ${amountAfterDiscount}, discount changed Rs. 0 to Rs. ${discount}`;
//     //
//     //     if (serviceTaxAmount > 0) {
//     //         message += `, GST/Service Charge changed Rs. 0 to Rs. ${serviceTaxAmount}`;
//     //     }
//     //
//     //     message += `, final amount Rs. ${finalAmount} by ${record?.userId?.name || ""}`;
//     //
//     //     return <>{message}</>;
//     // };
//     const changeLog = (record) => {
//         const tableLabel = record?.tableNo || record?.tableName || "-";
//         const actingUser = record.userName || record?.userId?.name || "System";
//
//         // ✅ FIX: Determine if we should show the Bill No part
//         const billDisplay = record.orderNo
//             ? `Bill No.:${record.orderNo}, `
//             : "";
//
//         if (
//             record.reportType === "KOT" ||
//             ["KOT_TRANSFER", "TABLE_TRANSFER", "TABLE_MERGE", "KOT_CREATED", "KOT_ADD_MORE", "ITEM_TRANSFER", "PAYMENT_EDIT"].includes(record.actionType)
//         ) {
//             return (
//                 <>
//                     Order ({billDisplay}Table:{tableLabel}){" "}
//                     {record.message || "-"} by {actingUser}
//                 </>
//             );
//         }
//         const subTotal = Number(record?.subTotal || 0);
//         const discount = Number(record?.discount || 0);
//         const serviceTaxAmount = Number(record?.serviceTaxAmount || 0);
//         const finalAmount = Number(record?.netAmount || 0);
//         const amountAfterDiscount = subTotal - discount;
//
//         // ✅ Apply the same logic here for standardized finalized logs
//         let message = `Order (${billDisplay}Table:${tableLabel}) subtotal Rs. ${subTotal}, after discount Rs. ${amountAfterDiscount}, discount changed Rs. 0 to Rs. ${discount}`;
//
//         if (serviceTaxAmount > 0) {
//             message += `, GST/Service Charge changed Rs. 0 to Rs. ${serviceTaxAmount}`;
//         }
//
//         message += `, final amount Rs. ${finalAmount} by ${actingUser}`;
//
//         return <>{message}</>;
//     };
//     // const columns = [
//     //     /*{
//     //         title: "Sr. No",
//     //         dataIndex: "serialNo",
//     //         key: "serialNo",
//     //         render: (text, record, index) => index + 1,
//     //     },*/
//     //     {
//     //         title: "Order No",
//     //         dataIndex: "orderNo",
//     //         key: "orderNo",
//     //     },
//     //     {
//     //         title: "Day Open Date",
//     //         dataIndex: "dayOpenDate",
//     //         key: "dayOpenDate",
//     //         render: (text, record) => {
//     //             return text && <>{moment(text).format('DD-MM-YYYY')}</>;
//     //         },
//     //     },
//     //     {
//     //         title: "Change Log",
//     //         dataIndex: "userId",
//     //         key: "userId",
//     //         render: (text, record) => {
//     //             return changeLog(record);
//     //         },
//     //     }
//     // ];
//
//     const columns = [
//         {
//             title: "Type",
//             dataIndex: "reportType",
//             key: "reportType",
//             render: (text, record) => <>{record.reportType || "Order"}</>,
//         },
//         {
//             title: "Order No",
//             dataIndex: "orderNo",
//             key: "orderNo",
//         },
//         {
//             title: "Table",
//             dataIndex: "tableNo",
//             key: "tableNo",
//             render: (text, record) => <>{record.tableNo || "-"}</>,
//         },
//         {
//             title: "Date",
//             dataIndex: "dayOpenDate",
//             key: "dayOpenDate",
//             render: (text, record) => {
//                 const finalDate = record.dayOpenDate || record.date;
//                 return finalDate && <>{moment(finalDate).format("DD-MM-YYYY hh:mm A")}</>;
//             },
//         },
//         {
//             title: "Change Log",
//             dataIndex: "userId",
//             key: "userId",
//             render: (text, record) => {
//                 return changeLog(record);
//             },
//         }
//     ];
//
//     let inputTypes = {
//         fields: [
//             {
//                 key: "fromD",
//                 label: "From Date",
//                 span: "col-md-3",
//                 type: "date",
//                 onChange: (x) => {
//                     props.form.setFieldsValue({
//                         fromD: x,
//                     });
//                 },
//             },
//             {
//                 key: "toD",
//                 label: "To Date",
//                 span: "col-md-3",
//                 type: "date",
//                 onChange: (x) => {
//                     props.form.setFieldsValue({
//                         toD: x,
//                     });
//                 },
//             },
//             /*            {
//                             key: "productIds",
//                             label: "Select Products",
//                             placeholder: "Choose Products",
//                             type: "select",
//                             showStar: true,
//                             span: "col-md-6",
//                             options: products,
//                             multiple: true,
//                             showSearch: true,
//                             keyAccessor: (x) => x._id,
//                             valueAccessor: (x) => `${x.name}`,
//                             onChange: (x) => {
//                                 props.form.setFieldsValue({
//                                     productIds: x,
//                                 });
//                             },
//                         }*/
//         ]
//
//     };
//
//     const getColumns = () => {
//         let columnArr = [];
//         _.each(columns, (item) => {
//             if (!item.hide) {
//                 columnArr.push(item);
//             }
//         });
//         return columnArr;
//     };
//
//     return (
//         // <PageHeader title={"Order Reporting"}>
//         <PageHeader title={"Order / KOT Activity Reporting"}>
//             <div className="row mb-3">
//                 <Form onSubmit={refreshTable}>
//                     <div className="card">
//                         <div className="card-body">
//                             <div className="form-elements-wrapper">
//                                 <div className={"row"}>
//                                     <div className="col-md-12 mb-3">
//                                         <div className="btn-group">
//                                             {[
//                                                 {key: "today", label: "Today"},
//                                                 {key: "7days", label: "Last 7 Days"},
//                                                 {key: "1month", label: "Last Month"},
//                                                 {key: "3months", label: "Last 3 Months"},
//                                                 {key: "custom", label: "Custom"},
//                                             ].map(tab => (
//                                                 // <button
//                                                 //     key={tab.key}
//                                                 //     className={`btn btn-outline-primary ${activeTab === tab.key ? 'activeDuration' : ''}`}
//                                                 //     onClick={() => handleDateTab(tab.key)}
//                                                 // >
//                                                 <button
//                                                     type="button"
//                                                     key={tab.key}
//                                                     className={`btn btn-outline-primary ${activeTab === tab.key ? 'activeDuration' : ''}`}
//                                                     onClick={() => handleDateTab(tab.key)}
//                                                 >
//                                                     {tab.label}
//                                                 </button>
//                                             ))}
//                                         </div>
//                                     </div>
//                                     {activeTab == "custom" && (
//                                         <>
//                                             <div className="col-md-2">
//                                                 <InputBox title={'From Date'}>
//                                                     <DatePicker
//                                                         value={dates.fromDate}
//                                                         showClear={true}
//                                                         placeholder={'Choose from Date'}
//                                                         onChange={(value) => setDates({...dates, fromDate: value})}
//                                                     />
//                                                 </InputBox>
//                                             </div>
//                                             <div className="col-md-2">
//                                                 <InputBox title={'To Date'}>
//                                                     <DatePicker
//                                                         value={dates.toDate}
//                                                         showClear={true}
//                                                         placeholder={'Choose to Date'}
//                                                         onChange={(value) => setDates({...dates, toDate: value})}
//                                                     />
//                                                 </InputBox>
//                                             </div>
//                                         </>
//                                     )}
//
//                                     {/*<button className="btn btn-info col-md-1 ms-3 h-25 mt-4"*/}
//                                     {/*        onClick={refreshTable}>*/}
//                                     <button
//                                         type="button"
//                                         className="btn btn-info col-md-1 ms-3 h-25 mt-4"
//                                         onClick={refreshTable}
//                                     >
//                                         Search
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </Form>
//             </div>
//             <div className="card">
//                 <div className="table-responsive">
//                     <Table
//                         apiRequest={apiRequest}
//                         columns={getColumns()}
//                         ref={tableRef}
//                     />
//                 </div>
//             </div>
//         </PageHeader>
//     );
// }
//
// export default Form.create()(OrderReporting);
import React, {useEffect, useRef, useState} from "react";
import {arraySorter, DatePicker, Form, InputBox, notification, Table} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import _ from "lodash";
import {fetchProduct, combinedReportingFxn} from "../products/actions";
import moment from "moment";

function OrderReporting(props) {
    let tableRef = useRef();
    const {getFieldValue} = props.form;
    let [products, setProducts] = useState([]);
    const [activeTab, setActiveTab] = useState("today");
    const [dates, setDates] = useState({
        fromDate: '',
        toDate: '',
    });

    const handleDateTab = (key) => {
        setActiveTab(key);
        const today = new Date();
        let from, to;

        switch (key) {
            case "today": from = to = today; break;
            case "7days":
                from = new Date(); from.setDate(today.getDate() - 7); to = today; break;
            case "1month":
                from = new Date(); from.setMonth(today.getMonth() - 1); to = today; break;
            case "3months":
                from = new Date(); from.setMonth(today.getMonth() - 3); to = today; break;
            case "custom": from = ''; to = ''; break;
            default: from = to = today;
        }
        setDates({fromDate: from, toDate: to});
    };

    /**
     * SAFE API REQUEST
     * This handles pagination without touching the global Table component.
     */
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                if (dates.fromDate && dates.toDate) {
                    params.fromD = moment(dates.fromDate).startOf('day')._d;
                    params.toD = moment(dates.toDate).endOf('day')._d;
                }

                const response = await combinedReportingFxn({ ...params });

                let finalData = [];
                let finalTotal = 0;

                // 1. Check for double nesting (axios response.data.data) or single nesting
                if (response?.data) {
                    const inner = response.data.data || response.data;
                    finalData = Array.isArray(inner) ? inner : [];
                    finalTotal = response.total || response.data.total || finalData.length;
                }
                // 2. Check if the response is a direct array
                else if (Array.isArray(response)) {
                    finalData = response;
                    finalTotal = response.length;
                }

                // Resolving exactly what TableMain.js expects
                resolve({
                    data: finalData,
                    total: finalTotal
                });

            } catch (error) {
                console.error("Fetch Error:", error);
                resolve({ data: [], total: 0 }); // Prevents Table crash
            }
        });
    };

    const getProducts = async (params = {}) => {
        params.results = 10000;
        const data = await fetchProduct({...params});
        if (data?.data?.data) setProducts(arraySorter(data.data.data));
    };

    useEffect(() => {
        getProducts();
        let currentDate = moment();
        props.form.setFieldsValue({
            fromD: moment(currentDate).startOf('month'),
            toD: moment(currentDate).endOf('month'),
        });
    }, []);

    const refreshTable = () => {
        if (tableRef.current) tableRef.current.reload();
    };

    const changeLog = (record) => {
        const tableLabel = record?.tableNo || record?.tableName || "-";
        const actingUser = record.userName || record?.userId?.name || "System";
        const billDisplay = record.orderNo ? `Bill No.:${record.orderNo}, ` : "";

        if (record.reportType === "KOT" || ["KOT_TRANSFER", "TABLE_TRANSFER", "TABLE_MERGE", "KOT_CREATED", "KOT_ADD_MORE", "ITEM_TRANSFER", "PAYMENT_EDIT"].includes(record.actionType)) {
            return <>Order ({billDisplay}Table:{tableLabel}) {record.message || "-"} by {actingUser}</>;
        }

        const subTotal = Number(record?.subTotal || 0);
        const discount = Number(record?.discount || 0);
        const gst = Number(record?.serviceTaxAmount || 0);
        const final = Number(record?.netAmount || 0);
        const afterDisc = subTotal - discount;

        return (
            <>
                Order ({billDisplay}Table:{tableLabel}) subtotal Rs. {subTotal}, after disc Rs. {afterDisc}, disc changed Rs. 0 to Rs. {discount}
                {gst > 0 ? `, GST/SC changed Rs. 0 to Rs. {gst}` : ""}
                , final amt Rs. {final} by {actingUser}
            </>
        );
    };

    const columns = [
        { title: "Type", dataIndex: "reportType", render: (t, r) => <>{r.reportType || "Order"}</> },
        { title: "Order No", dataIndex: "orderNo" },
        { title: "Table", dataIndex: "tableNo", render: (t, r) => <>{r.tableNo || "-"}</> },
        { title: "Date", dataIndex: "dayOpenDate", render: (t, r) => {
                const date = r.dayOpenDate || r.date;
                return date && <>{moment(date).format("DD-MM-YYYY hh:mm A")}</>;
            }},
        { title: "Change Log", dataIndex: "userId", render: (t, r) => changeLog(r) }
    ];

    return (
        <PageHeader title={"Order / KOT Activity Reporting"}>
            <div className="row mb-3">
                <Form onSubmit={refreshTable}>
                    <div className="card">
                        <div className="card-body">
                            <div className="form-elements-wrapper">
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="btn-group">
                                            {["today", "7days", "1month", "3months", "custom"].map(key => (
                                                <button type="button" key={key} className={`btn btn-outline-primary ${activeTab === key ? 'activeDuration' : ''}`} onClick={() => handleDateTab(key)}>
                                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    {activeTab === "custom" && (
                                        <>
                                            <div className="col-md-2"><InputBox title={'From'}><DatePicker value={dates.fromDate} onChange={v => setDates({...dates, fromDate: v})} /></InputBox></div>
                                            <div className="col-md-2"><InputBox title={'To'}><DatePicker value={dates.toDate} onChange={v => setDates({...dates, toDate: v})} /></InputBox></div>
                                        </>
                                    )}
                                    <button type="button" className="btn btn-info col-md-1 ms-3 h-25 mt-4" onClick={refreshTable}>Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
            <div className="card">
                <div className="table-responsive">
                    <Table
                        apiRequest={apiRequest}
                        columns={columns}
                        ref={tableRef}
                        pagination={{
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100']
                        }}
                    />
                </div>
            </div>
        </PageHeader>
    );
}

export default Form.create()(OrderReporting);
